import { __DEV__ } from '@/constants';
import { sleep } from '@/utils/sleep';

export function createEventLogger(options) {
    return new EventLogger(options);
}

export class EventLogger {
    install(Vue) {
        Vue.prototype.$logger = this;
    }

    logPageView(dimensions, options) {
        this._log(['pageview', dimensions], options);
    }

    logSocialInteraction(dimensions, options) {
        this._log(['social interaction', dimensions], options);
    }

    _log(payload, options) {
        const { sleepAfter } = options ?? {};

        if (__DEV__) {
            this._logToConsole(payload);
        }

        window?.adv_event?.push(payload);

        if (sleepAfter) {
            sleep(sleepAfter);
        }
    }

    _logToConsole(payload) {
        const [type, dimensions] = payload;

        console.log(type, dimensions);
    }
}
